var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5089 2.73277L13.2533 5.47722M11.6732 1.56839C12.4311 0.810535 13.6598 0.810535 14.4177 1.56839C15.1756 2.32625 15.1756 3.55499 14.4177 4.31284L3.73054 15H1.01367V12.228L11.6732 1.56839Z",
    stroke: "#0076A8",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBEdit);
export default __webpack_public_path__ + "static/media/Icon-b-edit.a2f93bc17d809d742fee80a0c5fe7a66.svg";
export { ForwardRef as ReactComponent };